import React from 'react';
// eslint-disable-next-line react/no-deprecated
import { render } from 'react-dom';

import '../../public/scss/main.scss';
// import ViewerApp from './ViewerApp';
import Viewer2 from './Viewer2';

render(<Viewer2 />, document.getElementById('root'));
